import ReactTable from 'react-table';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// Local Deps
import './ProcurementHistoryGrid.scss';
import { columns } from './gridConfig';

export default class ProcurementHistoryGrid extends PureComponent {
  static propTypes = {
    procurements: PropTypes.array.isRequired,
  };

  static defatultProps = {
    procurements: [],
  };
  static _formatProcurements(procurements) {
    return procurements.map(procurement => ({
      ...procurement,
      // This is just to reformat the data
      unitCost: `$${procurement.unitCost
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, '$&,')}`,
      // This actually creates the data as it is a calculated field
      extendedPrice: `$${(procurement.quantity * procurement.unitCost)
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, '$&,')}`,
    }));
  }

  render() {
    const { procurements } = this.props;

    return (
      <div className="nf-procurements-history__grid">
        <ReactTable
          data={ProcurementHistoryGrid._formatProcurements(procurements)}
          columns={columns}
          defaultPageSize={procurements.length}
          expander
          style={{ textAlign: 'center' }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grids/ProcurementHistoryGrid/ProcurementHistoryGrid.jsx